/**
 * 读取 boot.js 注入的环境变量。boot.js 由容器启动时按镜像 .env 生成，并在 app.js 之前执行。
 * @return {{ supportCanary: boolean, useServiceMesh: boolean, cosSdkLogsDownloadOrigin: string }}
 */
export function getBackendInjectEnvs() {
  return window.backendInjectEnvs || {};
}
